import api from './api';
import { User, AuthResponse } from '../types';

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const { data } = await api.post<AuthResponse>('/auth/login', { email, password });
    localStorage.setItem('geoz_token', data.access_token);
    return data;
  },

  async register(userData: Partial<User> & { password: string }): Promise<User> {
    const { data } = await api.post<User>('/users', userData);
    return data;
  },

  async getProfile(): Promise<User> {
    const { data } = await api.get<User>('/auth/profile');
    return data;
  },

  async switchCity(cityId: string): Promise<AuthResponse> {
    const { data } = await api.post<AuthResponse>('/auth/switch-city', { cityId });
    localStorage.setItem('geoz_token', data.access_token);
    return data;
  },

  logout() {
    localStorage.removeItem('geoz_token');
    window.location.href = '/login';
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('geoz_token');
  },
};

export const cityService = {
  async getById(cityId: string): Promise<any> {
    const { data } = await api.get(`/cities/${cityId}`);
    return data;
  },
  async getBoundary(cityId: string): Promise<any> {
    const { data } = await api.get(`/cities/${cityId}/boundary`);
    return data;
  },
};